var customArcherColors = {
  filledInputColors: {
    backgroundColor: 'rgba(33,33,33,0.06)'
  },
  riskMapColors: {
    low: '#43a047',
    mediumLow: '#1565c0',
    medium: '#fbc02d',
    mediumHigh: '#f57c00',
    high: '#c62828'
  },
  alertColors: {
    positive: '#3E9342',
    informative: '#1565c0',
    warning: '#CC6600',
    error: '#c62828'
  },
  iconColors: {
    completed: '#3E9342',
    success: '#3E9342',
    failed: '#c62828',
    error: '#c62828',
    remove: '#c62828',
    stopped: '#CC6600',
    warning: '#CC6600',
    cancelled: '#CC6600',
    inactive: '#212121',
    incomplete: '#9E9E9E',
    running: '#1565c0',
    queued: '#1565c0',
    info: '#ffffff',
    addnew: '#ffffff',
    close: '#ffffff',
    save: '#ffffff'
  },
  interactivityColors: {
    hover: '#DCE9F6',
    focus: '#DCE9F6'
  },
  getCustomAlertColors: function getCustomAlertColors(alertColor) {
    var _customArcherColors$a = customArcherColors.alertColors,
        success = _customArcherColors$a.positive,
        info = _customArcherColors$a.informative,
        warning = _customArcherColors$a.warning,
        error = _customArcherColors$a.error;
    var result = success;

    if (alertColor) {
      switch (alertColor) {
        case 'error':
          result = error;
          break;

        case 'info':
          result = info;
          break;

        case 'warning':
          result = warning;
          break;

        case 'success':
        default:
          result = success;
          break;
      }
    }

    return result;
  },
  getCustomActionIconColors: function getCustomActionIconColors(actionIcon) {
    var _customArcherColors$i = customArcherColors.iconColors,
        completed = _customArcherColors$i.completed,
        success = _customArcherColors$i.success,
        failed = _customArcherColors$i.failed,
        error = _customArcherColors$i.error,
        remove = _customArcherColors$i.remove,
        stopped = _customArcherColors$i.stopped,
        warning = _customArcherColors$i.warning,
        cancelled = _customArcherColors$i.cancelled,
        inactive = _customArcherColors$i.inactive,
        incomplete = _customArcherColors$i.incomplete;
    var result = '';

    if (actionIcon) {
      switch (actionIcon) {
        case 'COMPLETED':
          result = completed;
          break;

        case 'FAILED':
          result = failed;
          break;

        case 'WARNING':
          result = warning;
          break;

        case 'ERROR':
          result = error;
          break;

        case 'REMOVE':
          result = remove;
          break;

        case 'STOPPED':
          result = stopped;
          break;

        case 'CANCELLED':
          result = cancelled;
          break;

        case 'INACTIVE':
          result = inactive;
          break;

        case 'INCOMPLETE':
          result = incomplete;
          break;

        case 'SUCCESS':
          result = success;
          break;
      }
    }

    return result;
  },
  getCustomStatusIconColors: function getCustomStatusIconColors(statusIcon) {
    var _customArcherColors$i2 = customArcherColors.iconColors,
        completed = _customArcherColors$i2.completed,
        error = _customArcherColors$i2.error,
        cancelled = _customArcherColors$i2.cancelled,
        queued = _customArcherColors$i2.queued,
        warning = _customArcherColors$i2.warning;
    var result = '';

    if (statusIcon) {
      switch (statusIcon) {
        case 'CheckCircle':
          result = completed;
          break;

        case 'Error':
          result = error;
          break;

        case 'RemoveCircle':
          result = cancelled;
          break;

        case 'Warning':
          result = warning;
          break;

        case 'Queued':
          result = queued;
          break;
      }
    }

    return result;
  },
  getCustomExpansionPanelIconColors: function getCustomExpansionPanelIconColors(expansionPanelIconType) {
    var _customArcherColors$i3 = customArcherColors.iconColors,
        addnew = _customArcherColors$i3.addnew,
        close = _customArcherColors$i3.close,
        save = _customArcherColors$i3.save,
        info = _customArcherColors$i3.info;
    var result = '';

    if (expansionPanelIconType) {
      switch (expansionPanelIconType) {
        case 'ADD_NEW':
          result = addnew;
          break;

        case 'CLOSE':
          result = close;
          break;

        case 'SAVE':
          result = save;
          break;

        case 'INFO':
          result = info;
          break;
      }
    }

    return result;
  }
};
export { customArcherColors };